'use strict';

export default class Register {
  constructor() {
    // display register section when clicking on the primary navigation 
    $('.js-expand-register').on('click', function(e) {
        e.preventDefault();

        $('.register').addClass('expanded').slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    });

    $('.js-collapse-register').on('click', function(e) {
        e.preventDefault();

        $('.register').removeClass('expanded').slideUp({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    });
  }
}
